import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import type { ColumnsType } from "antd/es/table";
import Table from "antd/es/table";
import React from "react";
import ProgressIndicator from "../../components/ProgressIndicator";
import CustomMapComponent from "../../components/maps/CustomMapComponent";
import { getIcon, getIcon2 } from "../../components/maps/getIcon";
import strings from "../../config/localization";
import {
  useCheckinStatusQuery,
  useGetAllLocationsQuery,
  useGetTimeslotsQuery,
} from "../../services/appln";
import { getDefaultLocation, getDefaultZoom } from "../constants";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

interface LiveStatus {
  id: string;
  personnelName: string;
  designationName: string;
  liveTimestamp: string;
}

const columns: ColumnsType<LiveStatus> = [
  {
    title: strings.name,
    dataIndex: "personnelName",
    key: "personnelName",
  },
  {
    title: strings.designation,
    dataIndex: "designationName",
    key: "designationName",
  },
  {
    title: strings.status,
    dataIndex: "liveTimestamp",
    key: "liveTimestamp",
    render: (text, record, index) => (text !== "" ? strings.yes : strings.no),
  },
  {
    title: strings.liveLocationTime,
    dataIndex: "liveTimestamp",
    key: "liveTimestamp",
  },
];

function ListLiveStatusAsTable(props: any) {
  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              virtual
              scroll={{ y: 600 }}
              columns={columns}
              dataSource={props.data}
              pagination={false}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

function ListLiveStatusAsMap(props: any) {
  console.log("ListLiveStatusAsMap, props:", props);

  const [locationCoordinates, setLocationCoordinates] = React.useState([]);

  const [liveCoordinates, setLiveCoordinates] = React.useState([]);

  const locationsQueryResponse = useGetAllLocationsQuery({
    bandobastId: props.bandobastId,
    timeslotId: props.timeslotId,
  });

  React.useEffect(() => {
    if (locationsQueryResponse.isSuccess) {
      console.log(
        "ListLocations, locationsQueryResponse.data:",
        locationsQueryResponse.data,
      );
      const _populateColorMap = (data: any) => {
        // key: id, value: color
        const colorMap = new Map<string, string>();
        console.log("_populateColorMap, data:", data);

        const colors = ["red", "blue", "green"];
        const dataCopy = JSON.parse(JSON.stringify(data));
        const ranges = dataCopy
          .filter((e: any) => {
            return e.kind === "range";
          })
          .map((e: any) => {
            return { ...e };
          });

        ranges.forEach((range: any, range_index: number) => {
          console.log("_populateColorMap, range", range);
          colorMap.set(range.id, colors[range_index % colors.length]);
          const areas = dataCopy.filter((e: any) => {
            return e.kind === "area" && e.parentName === range.name;
          });
          console.log("_populateColorMap, areas", areas);
          areas.forEach((area: any) => {
            colorMap.set(area.id, colors[range_index % colors.length]);
            const subareas = dataCopy.filter((e: any) => {
              return e.kind === "subarea" && e.parentName === area.name;
            });
            console.log("_populateColorMap, subareas", subareas);
            subareas.forEach((subarea: any) => {
              colorMap.set(subarea.id, colors[range_index % colors.length]);
              const points = dataCopy.filter((e: any) => {
                return e.kind === "point" && e.parentName === subarea.name;
              });
              console.log("_populateColorMap, points", points);
              points.forEach((point: any) => {
                colorMap.set(point.id, colors[range_index % colors.length]);
              });
            });
          });
        });
        console.log("_populateColorMap, colorMap:", colorMap);
        return colorMap;
      };

      const locationsWithCoordinates = locationsQueryResponse.data.data.filter(
        (e: any) => {
          return e["latitude"] && e["longitude"];
        },
      );

      const colorMap = _populateColorMap(locationsWithCoordinates);
      console.log("XX, colorMap", colorMap);

      const kindMap = new Map<string, string>();
      locationsWithCoordinates.forEach((e: any) => {
        console.log("XX, e:", e);
        kindMap.set(e.id, e.kind);
      });
      console.log("XX, kindMap", kindMap);

      const locationCoordinates = locationsWithCoordinates.map((e: any) => {
        return {
          latitude: parseFloat(e["latitude"]),
          longitude: parseFloat(e["longitude"]),
          kind: e.kind,
          title: `${e.name} (${e.kind})`,
          details: `${e.name} (${e.kind})`,
          color: colorMap.get(e.id)!,
          icon: getIcon(colorMap.get(e.id)!, e.kind),
        };
      });
      setLocationCoordinates(locationCoordinates);

      const dataCopy = [...props.data];
      const tmp: any = dataCopy.map((e: any) => {
        console.log("XX, e", e);
        return {
          latitude: parseFloat(e["liveLatitude"]),
          longitude: parseFloat(e["liveLongitude"]),
          kind: "",
          title: "",
          details: `${e.personnelName} (${e.personnelMobileNumber})`,
          color: "",
          icon: getIcon2(
            `${kindMap.get(e.locationId)!}_${colorMap.get(
              e.locationId,
            )!}_person`,
          ),
        };
      });
      setLiveCoordinates(tmp);
    }
  }, [locationsQueryResponse]);

  return (
    <CustomMapComponent
      data={[...locationCoordinates, ...liveCoordinates]}
      onClose={() => {
        console.log("onCancelHandler");
      }}
      onSelect={(coordinate: any) => {}}
      defaultZoom={getDefaultZoom()}
      defaultCenter={getDefaultLocation()}
    />
  );
}

export default function ListLiveLocations(props: any) {
  const [value, setValue] = React.useState(0);

  const [timeslotMap, setTimeslotMap] = React.useState<any>(
    new Map<string, string>(),
  );

  const [selectedTimeslot, setSelectedTimeslot] = React.useState<any>("");

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const timeslotsQueryResponse = useGetTimeslotsQuery(props.bandobastId);
  React.useEffect(() => {
    if (!timeslotsQueryResponse.isSuccess) {
      return;
    }
    const timeslotMap = new Map<string, string>();
    timeslotsQueryResponse.data?.data.forEach((element: any) => {
      timeslotMap.set(element.name, element.id);
    });
    setSelectedTimeslot(timeslotsQueryResponse.data?.data[0].name);
    setTimeslotMap(timeslotMap);
  }, [timeslotsQueryResponse]);

  const checkinQueryResponse = useCheckinStatusQuery({
    bandobastId: props.bandobastId,
    timeslotId: timeslotMap.get(selectedTimeslot)!,
  });

  const bandobastContext = JSON.parse(localStorage.getItem("bandobast")!);
  const timeslotContext = JSON.parse(localStorage.getItem("timeslot")!);

  const [checkinStatus, setCheckinStatus] = React.useState([]);

  const [liveCoordinates, setLiveCoordinates] = React.useState([]);

  React.useEffect(() => {
    if (!checkinQueryResponse.isSuccess) {
      return;
    }

    setCheckinStatus(
      checkinQueryResponse.data.map((e: any) => {
        return e as LiveStatus;
      }),
    );

    const liveCoordinates = checkinQueryResponse.data.filter((e: any) => {
      return e["liveTimestamp"] && e["liveLatitude"] && e["liveLongitude"];
    });

    setLiveCoordinates(liveCoordinates);
  }, [checkinQueryResponse]);

  return (
    <Box sx={{ width: "100%" }}>
      {(checkinQueryResponse.isLoading || checkinQueryResponse.isFetching) && (
        <ProgressIndicator />
      )}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              options={Array.from(timeslotMap.keys())}
              value={selectedTimeslot}
              onChange={(e, value) => {
                setSelectedTimeslot(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="standard"
                  label={strings.timeslot}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label={strings.table}
                id="list-locations-as-table"
                aria-controls="list-locations-as-table"
              />
              <Tab
                label={strings.map}
                id="list-locations-as-map"
                aria-controls="list-locations-as-map"
              />
            </Tabs>
          </Grid>
        </Grid>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ListLiveStatusAsTable data={checkinStatus} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ListLiveStatusAsMap data={liveCoordinates} />
      </CustomTabPanel>
    </Box>
  );
}
